import 'url-polyfill';
import VueResource from 'vue-resource';
import Vue from 'vue';

Vue.use(VueResource);

const urlPrefix = `${window.location.origin}${window.SITE_URL}`;

export default {
  getStreetIdByPisBuildingId(params) {
    const url = new URL(
      'api_building/get_street_id_by_pis_bldg_id',
      urlPrefix,
    );

    return Vue.http.get(url.href, { params }).then(res => res.json());
  },
};
